<template>
  <div :class="[$style.chat, { [$style.smallScreen]: $screen === 's' }]">
    <div :class="$style.bubble">
      <BaseText>
        <span
          :class="$style.whiteSpace"
          v-html="message"
        />
      </BaseText>
    </div>
    <svg
      v-if="$screen !== 's'"
      :class="$style.tail"
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="17"
      viewBox="0 0 21 17"
      fill="none"
    >
      <path
        d="M8.65653 15.3093C9.4548 16.4155 11.1018 16.4155 11.9001 15.3093L19.9602 4.1405C20.9148 2.81777 19.9696 0.970118 18.3384 0.970119L2.21823 0.970119C0.587026 0.970119 -0.358131 2.81777 0.596432 4.1405L8.65653 15.3093Z"
        fill="white"
      />
    </svg>
  </div>
</template>

<script
  setup
  lang="ts"
>
defineProps<{
  message: string;
}>();
</script>

<style
  lang="scss"
  module
>
.chat {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.08);
  margin: $spacing 1.5 * $spacing;
  padding: 1.5 * $spacing $spacing;
  background: #fff;
  border-radius: 8px;

  &.smallScreen {
    padding: $spacing 0.5 * $spacing;
  }
}
.whiteSpace {
  white-space: pre-wrap;
}

.bubble {
  display: flex;
  padding: $spacing;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: $spacing;
  align-self: stretch;
}

.tail {
  position: absolute;
  right: 28.444px;
  bottom: -15px;
  -webkit-filter: drop-shadow(0 2px 12px 0 rgba(0, 0, 0, 0.08));
  filter: drop-shadow(0 2px 12px 0 rgba(0, 0, 0, 0.08));
  /* Similar syntax to box-shadow */
}
</style>
